export const PhoneRegex = /^((\+64)|0)((2\d{7,9})|([3-9]\d{7,8}))$/;
export const NameRegex = /^[a-zA-Z-\s]+$/;